import type { IProspect } from '../interfaces/prospects';

export const ProspectContactType = {
  Administrative: 'administrative',
  Billing: 'billing'
} as const;

export type ProspectContactType = (typeof ProspectContactType)[keyof typeof ProspectContactType];

export type CompanySize = 'micro' | 'sme' | 'corporate' | 'enterprise';

export const ProspectSalesModel = {
  AppAndInsurance: 'app_insurance',
  AppOnly: 'app_only'
} as const;

export type ProspectSalesModel = (typeof ProspectSalesModel)[keyof typeof ProspectSalesModel];

export const ProspectStatus = {
  PendingQuote: 'pending_quote',
  Quoted: 'quoted',
  PendingActivation: 'pending_activation',
  Inactive: 'inactive',
  Lost: 'lost'
} as const;

export type ProspectStatus = (typeof ProspectStatus)[keyof typeof ProspectStatus];

export type SalesModelSource = Pick<IProspect, 'salesModel'> | null | undefined;
